import React, { lazy } from 'react';
export function Bonos() {
  const bonos = [{
    image: 'https://cdn.magicpatterns.com/uploads/jLQR4pJohYbogQLsnVd4t5/ChatGPT_Image_5_may_2026__02_49_58_p.m.-removebg-preview.png',
    title: 'BONO 1 — Desafío de 7 Días',
    subtitle: 'El arranque que rompe la inercia desde el primer momento',
    desc: 'Una actividad corta y concreta por día durante 7 días consecutivos. Para empezar a sentir resultados desde la primera semana sin necesitar leer todo el sistema primero.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/ddVaG57Vjhck2gP4pWcvc7/ChatGPT_Image_5_may_2026__02_53_20_p.m.-removebg-preview.png',
    title: 'BONO 2 — Guía Práctica para Evitar Olvidos Diarios',
    subtitle: 'Las 10 reglas de oro en formato de cartel imprimible',
    desc: 'Para pegar en la heladera o en la entrada de la casa. El recordatorio más simple y efectivo que existe para reducir los olvidos cotidianos de forma inmediata.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/6shDRXB42HhRXpqRZ2qsYJ/ChatGPT_Image_5_may_2026__02_54_56_p.m.-removebg-preview.png',
    title: 'BONO 3 — Rutina Rápida de 5 Minutos',
    subtitle: 'Para los días en que el tiempo o las energías escasean',
    desc: '5 minutos por día son más de 30 horas de entrenamiento mental por año. Esta rutina garantiza que nunca haya un día en blanco, sin importar cómo esté el día.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/v4H5PUWobCFrcroCx5YaQG/ChatGPT_Image_5_may_2026__02_56_33_p.m.-removebg-preview.png',
    title: 'BONO 4 — Plan Conexión Familiar',
    subtitle: '8 actividades para hacer juntos y construir recuerdos nuevos',
    desc: 'El plan mensual de actividades familiares diseñadas para estimular cognitivamente al adulto mayor mientras generan momentos de conexión real entre generaciones. Con calendario mensual incluido.'
  }];
  const handleClick = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-orange-50 border-y border-orange-200" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <div className="text-center mb-12" data-id="element-17">
          <div className="inline-block bg-orange-200 text-orange-700 font-bold px-6 py-2 rounded-full tracking-widest text-sm mb-6 animate-pulse" data-id="element-18">
            🎁 GRATIS POR HOY
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-19">
            4 BONOS INCLUIDOS HOY
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-20">
          {bonos.map((bono, idx) => <div key={idx} className="bg-white border border-orange-200 rounded-2xl p-6 relative overflow-hidden group hover:border-orange-400 hover:shadow-lg transition-all shadow-sm flex flex-col" data-id="element-21">
              <div className="absolute top-0 right-0 w-32 h-32 bg-orange-100 rounded-bl-full -z-10 group-hover:bg-orange-200/70 transition-colors" data-id="element-22"></div>

              <div className="flex justify-center mb-4" data-id="element-23">
                <img src={bono.image} alt={bono.title} loading="lazy" onClick={handleClick} className="h-48 md:h-56 w-auto object-contain cursor-pointer drop-shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-24" />
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-25">
                {bono.title}
              </h3>
              <p className="text-orange-600 font-medium text-sm mb-4" data-id="element-26">
                {bono.subtitle}
              </p>
              <p className="text-slate-600" data-id="element-27">{bono.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}